import { render } from "./SelectorProducto.vue?vue&type=template&id=4f8ed65a&scoped=true"
import script from "./SelectorProducto.vue?vue&type=script&lang=js"
export * from "./SelectorProducto.vue?vue&type=script&lang=js"

import "./SelectorProducto.vue?vue&type=style&index=0&id=4f8ed65a&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4f8ed65a"]])

export default __exports__